<template>
	<!-- 废弃 -->
	<div>
		<el-table :data="tableData" max-height='500' style="width: 100%;margin-bottom: 20px;" row-key="tableKey"
		:tree-props="{children: 'goodsList', hasChildren: 'hasChildren'}">
			<el-table-column label="项目名称" width="280">
				<template slot-scope="scope">
					{{
						scope.row.goodsList?
						(scope.row.gift=='gift'?'赠品':scope.row.goodsName):
						scope.row.goodsName
					}}
				</template>
			</el-table-column>
			<el-table-column prop="customCode" label="条码" width="150">
				<template slot-scope="scope">
					{{scope.row.goodsList?'':scope.row.customCode}}
				</template>
			</el-table-column>
			<el-table-column label="规格" width="150">
				<template slot-scope="scope">
					{{
						scope.row.goodsList?
						(scope.row.gift=='gift'?'':scope.row.skuValue):
						scope.row.skuValue
					}}
				</template>
			</el-table-column>
			<el-table-column prop="originalPrice" label="标准价" width="80">
				<template slot-scope="scope">
					<span v-if="scope.row.goodsList">
						<span v-if="scope.row.gift=='gift'">0</span>
						<span v-else>{{scope.row.originalPrice}}</span>
					</span>
					<span v-else></span>
				</template>
			</el-table-column>
			<el-table-column label="活动" width="230">
				<template slot="header">
					活动 <img style="width:18px;vertical-align: sub;cursor: pointer;" @click="refreshActivityList" src="../../../assets/img/refresh.png"/>
				</template>
				<template slot-scope="scope" v-if="curPeople._id&&refreshingActivity===false">
					<!-- 二级和赠品不展示 -->
					<joinActivity
						v-if="scope.row.index!==undefined&&scope.row.gift!=='gift'"
						:activityName="scope.row.activityName"
						:memberType="curPeople._id===sankeId?0:curPeople.club_card. surplus_day"
						:memberId="curPeople._id"
						:petId="curPet.pet_id"
						:row="scope.row"
						:disabled="(scope.row.canActivity!==undefined&&scope.row.canActivity===false)||discountCard!==null||scope.row.huotiType===1"
						@change="changeJoinActivity"
					>
					</joinActivity>
				</template>
			</el-table-column>
			<el-table-column   label="优惠券" width="130">
				<template slot-scope="scope">
					<el-select v-if="scope.row.goodsList&&scope.row.gift!='gift'" v-model="scope.row.staff"  @change="changeStaff(scope.row)" multiple filterable placeholder="请选择">
						<el-option popper-class="select" v-for="item in staffList" :key="item._id" :label="item.basic_info.nick_name"
						:value="item.basic_info.nick_name"></el-option>
					</el-select>
				</template>
			</el-table-column>

			<el-table-column prop="price" label="优惠价" width="180">
				<template slot-scope="scope">
					<span v-if="scope.row.goodsList">
						<span v-if="scope.row.gift=='gift'">0</span>
						<span v-else>
							<span v-if="scope.row.goodsType==2">
								
								<el-input :disabled="!scope.row.customPrice" style="width:70px;" v-model="scope.row.price" @input="changePrice"></el-input>
								
							</span>
							
						</span>
					</span>
					<span v-else></span>
				</template>
			</el-table-column>
			<el-table-column label="数量" width="50">
				<template slot-scope="scope">
					<!-- <el-input v-if="scope.row.goodsType==2&&from=='self'" type="number" v-model="scope.row.num" @change="changeNum"></el-input> -->
					<span>{{scope.row.num}}</span>
				</template>
			</el-table-column>
			<el-table-column label="总金额" width="100">
				<template slot-scope="scope">
					<span v-if="scope.row.goodsList">
						<span v-if="scope.row.gift=='gift'">0</span>
						<span v-else>
							{{
								$public.toDoubleFixed2(scope.row.price*scope.row.num)||
								$public.toDoubleFixed2(scope.row.price)
							}}
						</span>
					</span>
					<span v-else></span>
				</template>
			</el-table-column>
			<el-table-column label="单位" width="80">
				<template slot-scope="scope">
					{{
						scope.row.goodsList?
						(scope.row.gift=='gift'?'':scope.row.unit):
						scope.row.unit
					}}
				</template>
			</el-table-column>
			<el-table-column   label="销售人员" width="130">
				<template slot-scope="scope">
					<el-select v-if="scope.row.goodsList&&scope.row.gift!='gift'" v-model="scope.row.staff"  @change="changeStaff(scope.row)" multiple filterable placeholder="请选择">
						<el-option popper-class="select" v-for="item in staffList" :key="item._id" :label="item.basic_info.nick_name"
						:value="item.basic_info.nick_name"></el-option>
					</el-select>
				</template>
			</el-table-column>
			<el-table-column   label="操作" width="180">
				<template slot-scope="scope">
					<span v-if="scope.row.gift!='gift'">
						<span v-if="scope.row.goodsType==1">
							<el-button @click="del_goods(scope.row)" type="danger" size="small">删除</el-button>
						</span>
						<span v-if="scope.row.goodsType==2">
							<el-button @click="del_server(scope.row)" type="danger" size="small">删除</el-button>
						</span>
						<span v-if="scope.row.goodsType==3">
							<el-button
							v-if="scope.row.goodsList"
							type="warning" size="small" @click="edit_group(scope.row)">编辑</el-button>
							<el-button
							v-if="scope.row.goodsList"
							@click="del_group(scope.row)" type="danger" size="small">删除</el-button>
						</span>
					</span>
				</template>
			</el-table-column>
			<template slot="empty">
				<img src="../../../assets/img/kong.png" style="width: 335px;padding-top:50px;" />
			</template>
		</el-table>
		<div v-if="dialogAddGroup_state">
			<dialogAddGroup :groupInfo="curGroupInfo" :groupTable="curGroupTable" @submit="dialogAddGroup_submit"></dialogAddGroup>
		</div>
	</div>
</template>

<script>
	import joinActivity from "../../../components/joinActivity.vue"
	import dialogAddGroup from "../../../components/dialog_addGroup.vue"
	import del from "../../../util/del.js"
	export default {
		components:{joinActivity,dialogAddGroup},
		data(){
			return{
				sankeId:process.env.VUE_APP_sanke,
				o:null,
				curIndex:-1,
				tableData:[],
				staffList:[],
				dialogAddGroup_state:false,
				curGroupInfo:null,
				curGroupTable:[],
				refreshingActivity:false,
				
				// 是否是活体单
				huotiType:-1,
			}
		},
		props:{
			table:{
				default:()=>{
					return []
				}
			},
			serviceGroup:{
				default:''
			},
			scanningCodeInput:{
				default:''
			},
			curPeople:{
				default:{}
			},
			curPet:{
				default:{}
			},
			discountCard:{
				default:null
			}
		},
		watch:{
			table(n){
				this.o.init(n)
				this.tableData = this.o.arr;
				if(n.length>0){
					if(n[0].huotiType===1){
						this.huotiType = 1;
					}else{
						this.huotiType = 0;
					}
				}else{
					this.huotiType = -1;
				}
			},
			scanningCodeInput(n){
				if(!this.$public.isNull(n)){
					this.getScanData(n)
				}
			},
			serviceGroup(n){
				if(!this.$public.isNull(n)){
					this.addServiceGroup(n)
				}
			}
		},
		mounted(){
			this.init();
		},
		methods: {
			init(){
				this.o = new del();
				this.getStaffList();
			},
			getScanData(code) {
				code = code.trim();
				if(this.huotiType===1){ // 活体单
					if(code.toString().length!==15){
						this.$message({
							message: '只能录入活体',
							type: 'error'
						});
						return ;
					}
				}else if(this.huotiType===0){ // 商品单
					if(code.toString().length===15){
						this.$message({
							message: '不能录入活体',
							type: 'error'
						});
						return ;
					}
				}else{  // 待定单
					if(code.toString().length===15){
						this.huotiType = 1;
					}else{
						this.huotiType = 0;
					}
				}
				if(code.toString().length===15){
					this.o.searchGoods(code,'',{allShop:true}).then(()=>{
						let addState = this.o.addGoods();
						if(addState.type==="success"){
							console.log('添加成功')
						}
						this.tableData = this.o.arr;
						this.$emit("change",{arr:this.o.arr,type:'add_goods'})
					})
				}else{
					this.o.searchGoods(code).then(()=>{
						let addState = this.o.addGoods();
						if(addState.type==="success"){
							console.log('添加成功')
						}
						this.tableData = this.o.arr;
						this.$emit("change",{arr:this.o.arr,type:'add_goods'})
					})
				}
			},
			// 改变参与的活动
			changeJoinActivity(obj){
				let curActivity = obj.curActivity;
				let curIndex = obj.curIndex;
				this.tableData[curIndex].activityList = obj.activityList;
				if(curActivity==''){
					this.tableData[curIndex].activityId='';
					this.tableData[curIndex].activityName='';
					this.tableData[curIndex].price=this.tableData[curIndex].originalPrice;
				}else{
					this.tableData[curIndex].activityId = curActivity._id;
					this.tableData[curIndex].activityName = curActivity.name;
					
					let consume_item = curActivity.consume_item;
					if(consume_item.is_rate){
						this.tableData[curIndex].price= this.$public.toDoubleFixed2(this.tableData[curIndex].originalPrice*consume_item.rate);
					}else if(consume_item.is_price){
						this.tableData[curIndex].price=consume_item.price;
					}
					this.o.init(this.tableData)
					// let k = this.tableData[curIndex].goodsName+'_bind_'+this.oldActivityName;
					// this.o.delGift(k);
					this.tableData = this.o.arr;
					// if (this.curActivity.give_goods.length > 0) {
					// 	this.dialog_goods_state = true;
					// 	this.ozeng = new del();
					// 	this.ozeng.init([])
					// }
				}
				this.$emit("change",{arr:this.o.arr,type:'changeActivity'})
			},
			refreshActivityList(){
				if(this.refreshingActivity === true) return ;
				this.refreshingActivity = true;
				setTimeout(()=>{
					for(let i=0;i<this.tableData.length;i++){
						this.tableData[i].activityId=''
						this.tableData[i].activityName=''
						this.tableData[i].activityList=[]
					}
					this.o.init(this.tableData)
					this.refreshingActivity = false;
				},1000)
				
			},
			/////////////////////////////////// 价格 //////////////////////////////////////
			changePrice(){
				this.$emit("change",{arr:this.o.arr,type:'changePrice'})
			},
			///////////////////////////////////////////  商品  ///////////////////////////
			del_goods(row){
				if (row.index === undefined) { // 删二级
					let posi = this.o.searchDel(row.customCode);
					this.$confirm('确定要删除?', '警告', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.o.del(posi,true);
						this.tableData = this.o.arr;
						this.$emit("change",{arr:this.o.arr,type:'del_goods'})
					})
				} else {
					this.$confirm('确定要删除?', '警告', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.o.del([row.index, -1]);
						this.tableData = this.o.arr;
						this.$emit("change",{arr:this.o.arr,type:'del_goods'})
					})
				}
			},
			/////////////////////////////////       服务       ////////////////////////////
			del_server(row){
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(() => {
					this.o.del([row.index, -1]);
					this.tableData = this.o.arr;
					this.$emit("change",{arr:this.o.arr,type:'del_server'})
				})
			},
			/////////////////////////////////////////////////            打开 商品套餐 弹窗
			addServiceGroup(item){
				if(item.basic_info.group_name){ // 商品套餐
					this.curGroupInfo = item;
					this.curGroupTable = [];
					this.curIndex = -1;
					this.dialogAddGroup_state = true;
				}else if(item.basic_info.product_name){  // 服务
					this.o.addService(item);
					this.tableData = this.o.arr;
				}
			},
			//////////////////////////////////////////////          商品套餐        //////////////////////////////////
			edit_group(row){
				this.curIndex = row.index;
				this.curGroupInfo = JSON.parse(row.originalGroupInfo);
				this.curGroupTable = JSON.parse(row.originalTable)
				this.dialogAddGroup_state = true;
			},
			del_group(row){
				let a = []
				for(let i=0;i<row.goodsList.length;i++){
					a.push(row.goodsList[i].customCode)
				}
				this.$confirm('套餐内包含条码:'+a.join(',')+'。   确定要删除这些条码?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.o.del([row.index,'x']);
					this.tableData = this.o.arr;
					this.$emit("change",{arr:this.o.arr,type:'del_group'})
				})
			},
			dialogAddGroup_submit(obj){
				if(obj.type==='close'){
					this.dialogAddGroup_state = false;
				}else if(obj.type==='success'){
					if(this.curIndex!==-1){
						this.o.del([this.curIndex,'x']);
						this.tableData = this.o.arr;
					}
					this.dialogAddGroup_state = false;
					this.o.addGoodsGroup(obj.data.groupInfo,obj.data.table);
					this.tableData = this.o.arr;
				}
			},
			///////////////////////////////////////////////         销售人员          /////////////////////////////
			changeStaff(row){
				if(row.index==0){
					for(let i=0;i<this.tableData.length;i++){
						this.tableData[i].staff=this.tableData[0].staff;
					}
				}
				for(let i=0;i<this.tableData.length;i++){
					let salesMans = []
					for(let b=0;b<this.tableData[i].staff.length;b++){
						for(let c=0;c<this.staffList.length;c++){
							if(this.staffList[c].basic_info.nick_name==this.tableData[i].staff[b]){
								let staff = {
									"userId": this.staffList[c]._id,
									"userName": this.tableData[i].staff[b],
								}
								salesMans.push(staff);
							}
						}
					}
					this.tableData[i].salesMans = salesMans;
				}
				this.o.init(this.tableData)
				this.$emit("change",{arr:this.o.arr,type:'changeStaff'})
			},
			// 获取销售人员列表
			getStaffList() {
				let params = {
					"keyword": '', //关键字
					"pageIndex": 1,
					"pageSize": 500,
				}
				this.$http.get('/api/Staff/List', params).then(res => {
					if (res.code == 0) {
						this.staffList = res.data.data;
					}
				})
			},
			///////////////////////////////////////////
		},
	}
</script>

<style>
</style>
